


















import { CareAllowenceModel } from '@/libs/Api';
import { careAllowencesStore } from '@/libs/care-allowences/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { partiesStore } from '@/libs/parties/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({ })
export default class CareAllowenceSelect extends Page {

    loading = false;
    search = "";
    debounce: any = null;

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() placeholder!: string;
    @Prop() readonly!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop() disabled!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) hideDetails!: boolean;

    @Watch("innerValue")
    innerValueChanged (v: string) {
        this.$emit("change", v);
    }

    get items(): CareAllowenceModel[] {
        return careAllowencesStore.useGetter(CrudGetter.Data);
    }

    mounted () {
        this.loadItems();
    }

    loadItems () {
        this.loading = true;
        careAllowencesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CareAllowenceModel>({ field: "name", index: 1, order: "asc" }, undefined, {
            pageIndex: 1,
            pageSize: 20
        }));
        this.subscribe(careAllowencesStore, CrudReponse.GetAll).then((e: CareAllowenceModel[]) => {
            this.loading = false;
        });
    }

	nameFunction(e: CareAllowenceModel) {
		return `${e.name} (${e.allowenceValue} Kč)`;
	}

}
